export default __webpack_public_path__ + "fcc125c4fef4b94c8b1321be020ae269.woff2";